import { Box, Snackbar, Typography } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { bool, func, number, oneOf, string } from 'prop-types';
import React from 'react';

const Alert = ({
  autoHideDuration = 3000,
  isOpen,
  onClose = () => {},
  variant,
  children = null,
  label = '',
  caption = '',
}) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isOpen}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
    >
      <MuiAlert elevation={6} severity={variant} onClose={onClose}>
        <Box sx={{ display: 'flex', flexGrow: 1, flexWrap: 'wrap', alignItems: 'center' }}>
          <div>
            <AlertTitle sx={{ mb: '0.5em' }}>{label}</AlertTitle>
            <Typography
              variant="body1"
              sx={{
                color: 'inherit',
              }}
            >
              {children}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'inherit',
              }}
            >
              {caption}
            </Typography>
          </div>
        </Box>
      </MuiAlert>
    </Snackbar>
  );
};

Alert.propTypes = {
  isOpen: bool.isRequired,
  variant: oneOf(['success', 'warning', 'error', 'info']).isRequired,
  children: string,
  label: string,
  caption: string,
  onClose: func,
  autoHideDuration: number,
};

export default Alert;
